(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunline-exploded"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('exploded-product')) {
    customElements.define('exploded-product', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-stage]');
        this.scene = this.querySelector('[data-scene]');
        this.modeToggle = this.querySelector('[data-mode-toggle]');
        this.editorPosition = this.querySelector('[data-editor-position]');
        this.editorPositionValue = this.querySelector('[data-editor-position-value]');
        this.partButtons = [...this.querySelectorAll('[data-part-button]')];
        this.partSlots = [...this.querySelectorAll('[data-part-slot]')];
        this.popoverDock = this.querySelector('[data-popover-dock]');
        const popoversById = new Map([...this.querySelectorAll('[data-part-popover]')].map((popover) => [popover.dataset.partId, popover]));
        this.partPopovers = new Map(this.partSlots.map((slot) => [slot, popoversById.get(slot.dataset.partId)]));
        if (this.popoverDock) {
          this.partPopovers.forEach((popover) => { if (popover) this.popoverDock.append(popover); });
        }
        this.railButtons = [...this.querySelectorAll('[data-rail-button]')];
        this.mobilePartSelect = this.querySelector('[data-mobile-part-select]');
        this.closeButtons = [...this.querySelectorAll('[data-popover-close]')];
        this.paddingPopover = this.querySelector('[data-padding-popover]');
        if (this.popoverDock && this.paddingPopover) this.popoverDock.append(this.paddingPopover);
        this.paddingPopoverClose = this.querySelector('[data-padding-popover-close]');
        this.copyPositionButton = this.querySelector('[data-copy-editor-position]');
        this.draggedSlot = null;
        this.selectionRevision = 0;
        this.setBreathingIntensity();
        this.alphaMasks = new WeakMap();
        this.detailLoads = new WeakMap();
        this.hotPart = null;
        this.pointerFrame = 0;
        this.canParallax = this.dataset.parallax === 'true' && this.dataset.reduceMotion !== 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.preloadObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.preloadObserver.disconnect();
          this.warmAlphaMasks();
        }, { rootMargin: '300px' });
        this.preloadObserver.observe(this);
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
        this.visibilityObserver.observe(this);

        this.stage?.addEventListener('pointermove', (event) => this.queuePointerMove(event), { signal, passive: true });
        this.stage?.addEventListener('pointerleave', () => {
          cancelAnimationFrame(this.pointerFrame);
          this.pointerFrame = 0;
          this.clearHotPart();
          this.centerParts();
        }, { signal, passive: true });
        this.stage?.addEventListener('click', (event) => this.handleStagePartClick(event), { signal, capture: true });

        this.modeToggle?.addEventListener('click', () => {
          this.setView(this.dataset.view === 'assembled' ? 'exploded' : 'assembled');
        }, { signal });

        this.partButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (this.suppressClick) {
              this.suppressClick = false;
              return;
            }
            this.selectPart(button);
          }, { signal });
        });

        this.railButtons.forEach((button) => {
          const prepare = () => {
            this.partSlots.filter((slot) => button.dataset.partGroup
              ? slot.dataset.partGroup === button.dataset.partGroup
              : slot.dataset.partId === button.dataset.partId
            ).forEach((slot) => this.prepareDetailImage(slot));
          };
          button.addEventListener('pointerenter', prepare, { signal, passive: true });
          button.addEventListener('focus', prepare, { signal });
          button.addEventListener('click', () => {
            if (button.getAttribute('aria-pressed') === 'true') {
              this.clearSelection();
              return;
            }
            if (button.dataset.partGroup === 'acolchados') {
              if (this.dataset.view === 'assembled') this.setView('exploded', false);
              this.selectGroup('acolchados', true);
              return;
            }
            const partButton = this.partButtons.find((item) => item.dataset.partId === button.dataset.partId);
            if (!partButton) return;
            if (this.dataset.view === 'assembled') this.setView('exploded', false);
            this.selectPart(partButton, true);
          }, { signal });
        });

        this.mobilePartSelect?.addEventListener('change', () => {
          const value = this.mobilePartSelect.value;
          if (!value) {
            this.clearSelection();
            return;
          }
          if (this.dataset.view === 'assembled') this.setView('exploded', false);
          if (value === 'group:acolchados') {
            this.selectGroup('acolchados');
            return;
          }
          const partButton = this.partButtons.find((item) => item.dataset.partId === value);
          if (partButton) this.selectPart(partButton);
        }, { signal });

        this.closeButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.clearSelection();
          }, { signal });
        });

        this.paddingPopoverClose?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.clearSelection();
        }, { signal });

        this.copyPositionButton?.addEventListener('click', async () => {
          const slot = this.draggedSlot;
          if (!slot) return;
          const isMobile = this.isMobileLayout();
          const x = isMobile ? slot.style.getPropertyValue('--mx') : slot.style.getPropertyValue('--x');
          const y = isMobile ? slot.style.getPropertyValue('--my') : slot.style.getPropertyValue('--y');
          const values = `Posición ${isMobile ? 'móvil' : 'escritorio'} — X ${x} · Y ${y}`;
          try { await navigator.clipboard.writeText(values); } catch (error) {}
          this.copyPositionButton.textContent = 'Valores copiados';
          window.setTimeout(() => { this.copyPositionButton.textContent = 'Copiar valores'; }, 1800);
        }, { signal });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.clearSelection();
        }, { signal });

        this.resizeObserver = new ResizeObserver(() => this.scheduleAssembly());
        if (this.stage) this.resizeObserver.observe(this.stage);
        this.scheduleAssembly();
        this.setView(this.dataset.view, false);

        if (window.Shopify?.designMode) {
          this.classList.add('is-editor');
          this.setupEditorDrag(signal);
        }

        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          this.setView('exploded', false);
          requestAnimationFrame(() => event.target.querySelector('[data-part-button]')?.click());
        }, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.preloadObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        cancelAnimationFrame(this.assemblyFrame);
        cancelAnimationFrame(this.pointerFrame);
      }

      isMobileLayout() {
        return window.matchMedia('(max-width: 959px)').matches;
      }

      setBreathingIntensity() {
        const intensity = Math.max(0, Number(this.dataset.breathingIntensity || 0));
        const sensitivity = intensity === 0 ? 0 : .35 + intensity / 100 * 1.75;
        this.style.setProperty('--se-breathing', sensitivity.toFixed(2));
      }

      getAlphaMask(image) {
        let mask = this.alphaMasks.get(image);
        if (mask !== undefined) return mask;
        try {
          const canvas = document.createElement('canvas');
          canvas.width = Math.min(320, image.naturalWidth);
          canvas.height = Math.max(1, Math.round(canvas.width * image.naturalHeight / image.naturalWidth));
          const context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          mask = context.getImageData(0, 0, canvas.width, canvas.height);
        } catch (error) {
          mask = null;
        }
        this.alphaMasks.set(image, mask);
        return mask;
      }

      warmAlphaMasks() {
        const images = this.querySelectorAll('.sunline-exploded__part-image');
        const pending = [...images];
        const schedule = window.requestIdleCallback
          ? (callback) => requestIdleCallback(callback)
          : (callback) => setTimeout(callback, 100);
        const next = () => {
          if (!this.isConnected) return;
          const image = pending.shift();
          if (!image) return;
          image.loading = 'eager';
          if (image.complete && image.naturalWidth) this.getAlphaMask(image);
          else image.addEventListener('load', () => schedule(() => this.getAlphaMask(image)), { once: true, signal: this.abortController.signal });
          schedule(next);
        };
        schedule(next);
      }

      isOpaquePart(button, clientX, clientY) {
        const slot = button.closest('[data-part-slot]');
        const image = slot?.classList.contains('is-detail-visible')
          ? button.querySelector('.sunline-exploded__detail-image')
          : button.querySelector('.sunline-exploded__part-image');
        if (!image || !image.complete || !image.naturalWidth) return true;

        const rect = image.getBoundingClientRect();
        let left = rect.left;
        let top = rect.top;
        let width = rect.width;
        let height = rect.height;
        if (image.classList.contains('sunline-exploded__detail-image')) {
          const scale = Math.min(rect.width / image.naturalWidth, rect.height / image.naturalHeight);
          width = image.naturalWidth * scale;
          height = image.naturalHeight * scale;
          left += (rect.width - width) / 2;
          top += (rect.height - height) / 2;
        }
        if (!width || !height || clientX < left || clientX > left + width || clientY < top || clientY > top + height) return false;

        const mask = this.getAlphaMask(image);

        if (!mask) return true;
        const x = Math.min(mask.width - 1, Math.max(0, Math.floor((clientX - left) / width * mask.width)));
        const y = Math.min(mask.height - 1, Math.max(0, Math.floor((clientY - top) / height * mask.height)));
        return mask.data[(y * mask.width + x) * 4 + 3] > 40;
      }

      partAtPoint(event) {
        return document.elementsFromPoint(event.clientX, event.clientY)
          .filter((element) => element.matches?.('[data-part-button]') && this.contains(element))
          .find((button) => this.isOpaquePart(button, event.clientX, event.clientY));
      }

      queuePointerMove(event) {
        this.pendingPointerEvent = event;
        if (this.pointerFrame) return;
        this.pointerFrame = requestAnimationFrame(() => {
          this.pointerFrame = 0;
          const latest = this.pendingPointerEvent;
          const stageRect = this.canParallax ? this.stage.getBoundingClientRect() : null;
          this.updateHotPart(latest);
          if (this.canParallax && !latest.target.closest('[data-mode-toggle], [data-rail-button], [data-part-popover], [data-padding-popover]')) this.moveParts(latest, stageRect);
        });
      }

      updateHotPart(event) {
        if (this.dataset.view !== 'exploded' || event.target.closest('[data-mode-toggle], [data-rail-button], [data-part-popover], [data-padding-popover]')) {
          this.clearHotPart();
          return;
        }
        const hotPart = this.partAtPoint(event);
        if (hotPart === this.hotPart) return;
        this.clearHotPart();
        this.hotPart = hotPart;
        this.hotPart?.classList.add('is-hot');
      }

      clearHotPart() {
        if (!this.hotPart) return;
        this.hotPart.classList.remove('is-hot');
        this.hotPart = null;
      }

      handleStagePartClick(event) {
        if (this.dataset.view !== 'exploded' || event.detail === 0 || event.target.closest('[data-mode-toggle], [data-rail-button], [data-part-popover], [data-padding-popover]')) return;
        const clickedButton = event.target.closest('[data-part-button]');
        if (this.suppressClick) {
          this.suppressClick = false;
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const actualButton = this.partAtPoint(event);
        if (!actualButton) {
          this.clearSelection();
          if (clickedButton) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
          return;
        }
        if (actualButton !== clickedButton) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (actualButton) this.selectPart(actualButton);
        }
      }

      scheduleAssembly() {
        cancelAnimationFrame(this.assemblyFrame);
        this.assemblyFrame = requestAnimationFrame(() => this.prepareAssembly());
      }

      prepareAssembly() {
        if (!this.stage) return;
        const stageWidth = this.stage.clientWidth;
        const stageHeight = this.stage.clientHeight;
        if (!stageWidth || !stageHeight) return;

        this.partSlots.forEach((slot) => {
          const styles = getComputedStyle(slot);
          const currentX = parseFloat(styles.left);
          const currentY = parseFloat(styles.top);
          const currentWidth = parseFloat(styles.width);
          const targetX = stageWidth * Number(slot.dataset.assembledX || 50) / 100;
          const targetY = stageHeight * Number(slot.dataset.assembledY || 50) / 100;
          const targetWidth = stageWidth * Number(slot.dataset.assembledWidth || 30) / 100;
          const targetRotation = Number(slot.dataset.assembledRotation || 0);

          slot.style.setProperty('--assembled-x', `${targetX - currentX}px`);
          slot.style.setProperty('--assembled-y', `${targetY - currentY}px`);
          slot.style.setProperty('--assembled-scale', currentWidth ? targetWidth / currentWidth : 1);
          slot.style.setProperty('--assembled-rotation', `${targetRotation}deg`);
        });

        const selectedSlots = this.partSlots.filter((slot) => slot.classList.contains('is-selected'));
        if (selectedSlots.length > 1 && selectedSlots.every((slot) => slot.classList.contains('is-group-selected'))) {
          this.prepareGroupFocus(selectedSlots);
        } else if (selectedSlots[0]) {
          this.prepareFocus(selectedSlots[0]);
        }
      }

      prepareFocus(slot) {
        if (!this.stage || !slot) return;
        const styles = getComputedStyle(slot);
        const currentX = parseFloat(styles.left);
        const currentY = parseFloat(styles.top);
        const currentWidth = parseFloat(styles.width);
        const isMobile = this.isMobileLayout();
        const targetX = this.stage.clientWidth * (isMobile ? .5 : .43);
        const isSoleDetail = slot.dataset.detailSole === 'true';
        const targetY = this.stage.clientHeight * (isMobile ? (isSoleDetail ? .33 : .27) : .46);
        const targetWidth = Math.min(this.stage.clientWidth * (isMobile ? .58 : .34), 500);
        const scale = Math.min(Math.max(targetWidth / currentWidth, 1.08), 2.15);
        const sceneScale = Number.parseFloat(getComputedStyle(this).getPropertyValue('--se-scene-scale')) || 1;

        slot.style.setProperty('--focus-x', `${targetX - currentX}px`);
        slot.style.setProperty('--focus-y', `${targetY - currentY}px`);
        slot.style.setProperty('--focus-scale', scale);
        slot.style.setProperty('--focus-inverse', 1 / (scale * sceneScale));
      }

      prepareGroupFocus(slots) {
        if (!this.stage || !slots.length) return;
        const stageWidth = this.stage.clientWidth;
        const stageHeight = this.stage.clientHeight;
        const isMobile = this.isMobileLayout();
        const targetX = stageWidth * (isMobile ? .5 : .43);
        const targetY = stageHeight * (isMobile ? .25 : .46);
        const targetWidth = Math.min(stageWidth * (isMobile ? .38 : .26), 520);
        const gap = Math.min(stageWidth * (isMobile ? .19 : .13), 180);
        const sceneScale = Number.parseFloat(getComputedStyle(this).getPropertyValue('--se-scene-scale')) || 1;
        slots.forEach((slot, index) => {
          const styles = getComputedStyle(slot);
          const currentX = parseFloat(styles.left);
          const currentY = parseFloat(styles.top);
          const currentWidth = parseFloat(styles.width);
          const scale = Math.min(Math.max(targetWidth / currentWidth, 1.08), 2.35);
          const direction = index === 0 ? -1 : 1;
          slot.style.setProperty('--group-x', `${targetX + direction * gap - currentX}px`);
          slot.style.setProperty('--group-y', `${targetY - currentY}px`);
          slot.style.setProperty('--group-scale', scale);
          slot.style.setProperty('--group-inverse', 1 / (scale * sceneScale));
          slot.style.setProperty('--group-popover-shift', isMobile && index === 0 ? `${gap / scale}px` : '0px');
        });
      }

      setupEditorDrag(signal) {
        this.partButtons.forEach((button) => {
          button.addEventListener('pointerdown', (event) => {
            if (event.button !== 0) return;
            const slot = button.closest('[data-part-slot]');
            if (!slot) return;
            const origin = { x: event.clientX, y: event.clientY };
            let dragging = false;

            const move = (moveEvent) => {
              if (!dragging && Math.hypot(moveEvent.clientX - origin.x, moveEvent.clientY - origin.y) < 6) return;
              if (!dragging) {
                dragging = true;
                this.clearSelection();
                slot.classList.add('is-dragging');
                button.setPointerCapture?.(event.pointerId);
              }

              const rect = (this.scene || this.stage).getBoundingClientRect();
              const x = Math.min(100, Math.max(0, (moveEvent.clientX - rect.left) / rect.width * 100));
              const y = Math.min(100, Math.max(0, (moveEvent.clientY - rect.top) / rect.height * 100));

              if (this.dataset.view === 'assembled') {
                slot.dataset.assembledX = x.toFixed(0);
                slot.dataset.assembledY = y.toFixed(0);
                this.prepareAssembly();
              } else {
                const isMobile = this.isMobileLayout();
                slot.style.setProperty(isMobile ? '--mx' : '--x', `${x.toFixed(1)}%`);
                slot.style.setProperty(isMobile ? '--my' : '--y', `${y.toFixed(1)}%`);
              }
              this.draggedSlot = slot;

              if (this.editorPosition && this.editorPositionValue) {
                this.editorPosition.hidden = false;
                this.editorPositionValue.textContent = `X ${x.toFixed(0)}% · Y ${y.toFixed(0)}%`;
              }
            };

            const end = () => {
              if (dragging) {
                slot.classList.remove('is-dragging');
                this.suppressClick = true;
                window.setTimeout(() => {
                  if (this.editorPosition) this.editorPosition.hidden = true;
                }, 2800);
              }
              window.removeEventListener('pointermove', move);
              window.removeEventListener('pointerup', end);
              window.removeEventListener('pointercancel', end);
            };

            window.addEventListener('pointermove', move, { signal });
            window.addEventListener('pointerup', end, { once: true, signal });
            window.addEventListener('pointercancel', end, { once: true, signal });
          }, { signal });
        });
      }

      setView(view, focusToggle = true) {
        const isExploded = view === 'exploded' || this.dataset.hasAssembledImage !== 'true';
        this.clearSelection();
        this.centerParts();
        this.clearHotPart();
        this.dataset.view = isExploded ? 'exploded' : 'assembled';

        if (this.modeToggle) {
          this.modeToggle.setAttribute('aria-pressed', String(isExploded));
          const label = this.modeToggle.querySelector(isExploded ? '.sunline-exploded__mode-label--assemble' : '.sunline-exploded__mode-label--explode')?.textContent?.trim();
          if (label) this.modeToggle.setAttribute('aria-label', label);
          if (focusToggle) this.modeToggle.focus({ preventScroll: true });
        }

        this.partButtons.forEach((button) => {
          button.tabIndex = isExploded ? 0 : -1;
        });
      }

      selectPart(button, fromRail = false) {
        if (this.dataset.view !== 'exploded') return;
        const slot = button.closest('[data-part-slot]');
        const popover = this.partPopovers.get(slot);
        if (!slot || !popover) return;

        const revision = ++this.selectionRevision;
        if (this.paddingPopover) this.paddingPopover.hidden = true;

        const update = () => {
          this.dataset.hasSelection = 'true';
          this.partButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.railButtons.forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.partId === button.dataset.partId)));
          if (this.mobilePartSelect) this.mobilePartSelect.value = button.dataset.partId;
          this.partSlots.forEach((item) => {
            const itemPopover = this.partPopovers.get(item);
            item.classList.toggle('is-selected', item === slot);
            item.classList.remove('is-group-selected');
            item.classList.remove('is-detail-visible');
            if (itemPopover) itemPopover.hidden = item !== slot || fromRail;
          });
        };

        update();

        this.prepareFocus(slot);
        this.revealDetail(slot, revision);
      }

      selectGroup(group, fromRail = false) {
        if (this.dataset.view !== 'exploded') return;
        const groupSlots = this.partSlots.filter((slot) => slot.dataset.partGroup === group);
        const groupButtons = this.partButtons.filter((button) => button.dataset.partGroup === group);
        if (!groupSlots.length) return;
        const revision = ++this.selectionRevision;
        this.dataset.hasSelection = 'true';
        this.partButtons.forEach((item) => item.setAttribute('aria-pressed', String(groupButtons.includes(item))));
        this.railButtons.forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.partGroup === group)));
        if (this.mobilePartSelect) this.mobilePartSelect.value = `group:${group}`;
        this.partSlots.forEach((item) => {
          const active = groupSlots.includes(item);
          item.classList.toggle('is-selected', active);
          item.classList.toggle('is-group-selected', active);
          item.classList.remove('is-detail-visible');
          const popover = this.partPopovers.get(item);
          if (popover) popover.hidden = true;
        });
        if (this.paddingPopover) this.paddingPopover.hidden = fromRail;
        this.prepareGroupFocus(groupSlots);
        groupSlots.forEach((slot) => this.revealDetail(slot, revision));
      }

      clearSelection() {
        this.selectionRevision++;
        this.dataset.hasSelection = 'false';
        if (this.paddingPopover) this.paddingPopover.hidden = true;
        this.partButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.railButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        if (this.mobilePartSelect) this.mobilePartSelect.value = '';
        this.partSlots.forEach((item) => {
          item.classList.remove('is-selected');
          item.classList.remove('is-group-selected');
          item.classList.remove('is-detail-visible');
          const popover = this.partPopovers.get(item);
          if (popover) popover.hidden = true;
        });
      }

      prepareDetailImage(slot) {
        const image = slot.querySelector('.sunline-exploded__detail-image');
        if (!image) return Promise.resolve(false);
        if (this.detailLoads.has(image)) return this.detailLoads.get(image);
        image.loading = 'eager';
        image.decoding = 'async';
        const ready = image.decode().then(() => true, () => Boolean(image.complete && image.naturalWidth));
        this.detailLoads.set(image, ready);
        return ready;
      }

      async revealDetail(slot, revision) {
        if (!await this.prepareDetailImage(slot)) return;
        if (this.isConnected && this.selectionRevision === revision && this.dataset.view === 'exploded' && slot.classList.contains('is-selected')) {
          slot.classList.add('is-detail-visible');
        }
      }

      moveParts(event, rect = this.stage.getBoundingClientRect()) {
        if (this.dataset.view !== 'exploded') return;
        const normalizedX = (event.clientX - rect.left) / rect.width - .5;
        const normalizedY = (event.clientY - rect.top) / rect.height - .5;
        this.partSlots.forEach((slot) => {
          const depth = Number(slot.dataset.depth || 1);
          slot.style.setProperty('--parallax-x', `${normalizedX * depth * .45}px`);
          slot.style.setProperty('--parallax-y', `${normalizedY * depth * .3}px`);
        });
      }

      centerParts() {
        this.partSlots.forEach((slot) => {
          slot.style.setProperty('--parallax-x', '0px');
          slot.style.setProperty('--parallax-y', '0px');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
